var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonTemplate',{attrs:{"on-click":() => _vm.onClick(),"icon":"code-slash","title":"Insert embedded URL"}})
}
var staticRenderFns = []

export { render, staticRenderFns }